import { PostAPI } from 'Components/Helper/Helpers';

export const Insert = async (request) => {
    return PostAPI(request, 'Onboarding/Insert');
};

export const Update = async (request) => {
    return PostAPI(request, 'Onboarding/Update');
};

export const SelectByID = async (request) => {
    return PostAPI(request, 'Onboarding/SelectByID');
};

export const SelectForOnboardingReport = async (request) => {
    return PostAPI(request, 'Onboarding/SelectForOnboardingReport');
};

export const OnboardtoNSDL = async (request) => {
    return PostAPI(request, 'Onboarding/OnboardtoNSDL');
};

export const UpdateTIDMID = async (request) => {
    return PostAPI(request, 'Onboarding/UpdateTIDMID');
};

export const SelectAgentCode = async (request) => {
    return PostAPI(request, 'Onboarding/GetAgentCode');
};

export const BulkOnboarding = async (request) => {
    return PostAPI(request, 'Onboarding/BulkOnboarding');
};

export const DownloadTemplete = async (request) => {
    return PostAPI(request, 'Onboarding/DownloadTemplete');
};

export const BulkTIDMID = async (request) => {
    return PostAPI(request, 'Onboarding/BulkUpdateTIDMID');
};